module.exports = __webpack_public_path__ + "static/media/img-ami-2.922deb01.svg";